import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { waSales } from '../../utils/support';

const CTAFinal = () => {
  const revealRef = useScrollReveal();

  return (
    <section className="bg-navy-2 py-16 md:py-24 px-4 text-center overflow-hidden">
      <div
        ref={revealRef}
        className="max-w-4xl mx-auto reveal-up"
      >
        <h2 className="font-display text-[32px] md:text-[36px] font-bold text-white mb-6 leading-tight">
          Pronto para emitir laudos do jeito certo?
        </h2>
        <p className="text-lg md:text-[20px] text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
          Crie a conta sem cartão de crédito.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 mb-12">
          {[
            "Configuração em menos de 5 minutos",
            "Suporte em português no WhatsApp",
            "Cancele quando quiser"
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-sm text-white/80">
              <Check className="w-4 h-4 text-white" aria-hidden="true" />
              {item}
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center gap-6">
          <Link to="/login" className="btn-convert group text-base px-10">
            Criar minha conta grátis
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
          </Link>

          <a
            href={waSales()}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/70 underline hover:text-white text-sm font-medium transition-colors min-h-[44px] inline-flex items-center"
          >
            Falar com o time antes
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTAFinal;
